function getPortalType() {
  return window.__INITIAL_DATA__.portalType //Either 'Employee' or 'Client' depending on the portal
}

export default {
  getPortalType
}
